import HopTimusAvatar from '../../HopTimusAvatar/HopTimusAvatar'
import useHopTimusAskLine from './useHopTimusAskLine'
import { AskField, AskLineButton, AskPlaceholder, ShortcutKey } from './styled-components'

const HopTimusAskLineContent = () => {
  const { label, example, shortcut, onAsk } = useHopTimusAskLine()

  return (
    <AskLineButton type='button' aria-label={label} aria-keyshortcuts='Control+K Meta+K' onClick={onAsk}>
      <HopTimusAvatar />
      <AskField aria-hidden='true'>
        <AskPlaceholder>{example}</AskPlaceholder>
        <ShortcutKey>{shortcut}</ShortcutKey>
      </AskField>
    </AskLineButton>
  )
}

export default HopTimusAskLineContent
